/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_BoldInputs */

const en_entity_bold = /** @type {(inputs: Entity_BoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bold`)
};

const de_entity_bold = /** @type {(inputs: Entity_BoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fett`)
};

/**
* | output |
* | --- |
* | "Bold" |
*
* @param {Entity_BoldInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const entity_bold = /** @type {((inputs?: Entity_BoldInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_BoldInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_bold(inputs)
	return de_entity_bold(inputs)
});